
export const currencyFormatter = Intl.NumberFormat(undefined,{
  currency:"usd",
  style:"currency",
  minimumFractionDigits:0
});